  
<div class="site-header app-header">
<div class="before-login-items">
<div class="site-logo-con" style="display: flex; align-items: center">
<img alt="" class="site-logo ng-star-inserted" src="https://royall444.com/api/users/images/theme-1742469725615-royal444.png" style="cursor: pointer"/><!-- --><!-- -->
</div>
<div class="login-signup-uname-pass">
<ul class="desktopviewButton hideDekstop showDekstop" style="position: relative">
<li><!-- --></li>
<li class="search float-left">
<a><i class="fas fa-search-plus" id="searchiconDesktopID"></i></a>
</li>
<li class="float-left account">
<div class="d-flex">
<div class="form-group mb-0">
<input class="form-control uname ng-untouched ng-pristine ng-valid" name="usernameForLogin" placeholder="Username" type="text"/>
</div>
<div class="form-group mb-0 margin-setting">
<input autocomplete="new-password" class="form-control pass ng-untouched ng-pristine ng-valid" name="passForLogin" placeholder="Password" type="password"/>
</div>
</div>
<!-- -->
</li>
<!-- -->
</ul>
<!-- -->
<div class="login-signup">
<!-- --><button class="btn login me-1 222">
<b style="width: 33px; height: 18px">
                        Login </b><i class="fa fa-sign-in"></i></button><!-- -->
</div>
<!-- -->
</div>
</div>
</div>
<app-header-nav class="hideMobile"></app-header-nav>
<div aria-hidden="true" aria-labelledby="exposureModalLabel" class="modal fade exposureModals" id="exposureModalss" tabindex="-1">
<div class="modal-dialog modal-md">
<div class="modal-content">
<div class="modal-header exposure-details">
<h1 class="modal-title" id="exposureModalLabel">
                      Exposure Detail
                    </h1>
<button aria-label="Close" class="close" data-bs-dismiss="modal" type="button">
<span aria-hidden="true">×</span>
</button>
</div>
<div class="modal-body">
<table class="table table-bordered">
<thead>
<tr class="theme1font">
<th class="text-center">
                            Sport Name
                          </th>
<th class="text-center" style="width: 50%">
                            Event Name
                          </th>
<th class="text-center">
                            Market Name
                          </th>
<th class="text-center">
                            Trade
                          </th>
</tr>
</thead>
<!-- -->
<tfoot>
<tr class="exposurebody">
<td class="text-center" colspan="4">
                            No real-time records found
                          </td>
</tr>
</tfoot>
<!-- -->
</table>
</div>
</div>
</div>
</div>
<div aria-hidden="true" aria-labelledby="ageconfirmationModalNew" class="modal fade" id="ageconfirmationModalNew" tabindex="-1">
<div class="modal-dialog modal-dialog-centered">
<div class="modal-content">
<div class="modal-body ageconfirmationModalclass">
<div class="header-popup">
<a aria-label="Close" class="ui-link" data-bs-dismiss="modal"><i class="fas fa-times"></i></a>
</div>
<div class="login-panel-container confirm-container">
<div class="confirm-text">
<div class="text1 text-confirm-bold">
                          Non-Gambling Territories.
                        </div>
<hr class="confirm-line"/>
<div class="text2">
                          Connecting to our site from non gambling countries, it
                          will be User's responsibility to ensure that their use
                          of the service is lawful.
                        </div>
</div>
<div class="confirm-text">
<div class="text1 text-confirm-bold">
                          Underage gambling is prohibited.
                        </div>
<hr class="confirm-line"/>
<div class="text2">
                          Please confirm if you are
                          <span>18 years old and above</span>
                          as of today.
                        </div>
</div>
<div class="confirm-button">
<!-- --><button class="btn-verification btn-confirm" data-bs-dismiss="modal" routerlink="/login" tabindex="0">
<span>Confirm</span></button><!-- --><button class="btn-verification" data-bs-dismiss="modal">
<a style="text-decoration: none"><span>Exit</span></a>
</button>
</div>
</div>
</div>
</div>
</div>
</div>